/*!
 * Copyright (C) Microsoft Corporation. All rights reserved.
 */
export function getStyles(props) {
    var fonts = props.theme.fonts, showExpandEditorButton = props.showExpandEditorButton;
    return {
        root: {
            border: '0',
            display: 'flex',
            width: '100%',
        },
        formulaEditor: {
            width: "calc(100% - " + (showExpandEditorButton ? 35 : 0) + "px)",
        },
        subComponentStyles: {
            expandEditorIcon: {
                root: {
                    fontSize: fonts === null || fonts === void 0 ? void 0 : fonts.xLarge.fontSize,
                    width: 35,
                },
            },
        },
    };
}
//# sourceMappingURL=PowerFxFormulaEditor.styles.js.map